import React, { useState, useEffect, useRef } from "react";
import { useLocation, useNavigate, Link } from "react-router-dom";
import "../../../css/dashboard.css"
import axios from 'axios';
import CommonTable from "../../component/table_list/common_table";
import CommonTableRow from "../../component/table_list/common_tablerow";
import CommonTableColumn from "../../component/table_list/common_tablecolumn";
import Pagination from "react-js-pagination";
import styled from "styled-components"
import Menu from "../../component/main_menu"
import { useAuthContext } from '../../common/ProtectedLayout';
import { regionData } from "../../common/regionData";
import DaumPostcode from 'react-daum-postcode';
import { formatDate } from "../../utils/format_date";

function RequestManager(props) {

    // 기사등급 색상 (배경색, 글씨색)
    const RANK_STYLES = {
        '레전드': { bg: '#FF1744', text: '#FFFFFF' },
        '라이트닝': { bg: '#FFFF00', text: '#333333' },
        '코스믹': { bg: '#1a0033', text: '#FFFFFF' },
        '토파즈': { bg: '#FF8C00', text: '#FFFFFF' },
        '아메시스트': { bg: '#9933CC', text: '#FFFFFF' },
        '에메랄드': { bg: '#50C878', text: '#FFFFFF' },
        '에메라드': { bg: '#50C878', text: '#FFFFFF' },
        '사파이어': { bg: '#0F52BA', text: '#FFFFFF' },
        '루비': { bg: '#E0115F', text: '#FFFFFF' },
        '플래티넘': { bg: '#E5E4E2', text: '#333333' },
        '골드': { bg: '#FFD700', text: '#333333' },
        '실버': { bg: '#C0C0C0', text: '#333333' },
        '브론즈': { bg: '#CD7F32', text: '#FFFFFF' },
        '아이언': { bg: '#708090', text: '#FFFFFF' }
    };

    const location = useLocation();
    const navigate = useNavigate();
    const [isValidAccess, setIsValidAccess] = useState(false);

    const [managerInfo, setManagerInfo] = useState({});
    const [reserveList, setReserveList] = useState([]);
    const [page, setPage] = useState(1);
    const items = 10;
    const hadlePageChange = (page) => { setPage(page) };
    const [reserveCount, setReserveCount] = useState(0);
    const auth = useAuthContext();
    const modalCorrective = useRef();
    const addressModalRef = useRef();
    const fileInputRef = useRef();

    const careerOptions = Array.from({ length: 50 }, (_, i) => i + 1);
    const [searchQuery, setSearchQuery] = useState('');
    const [addressModalOpen, setAddressModalOpen] = useState(false);
    const [productList, setProductList] = useState([]);

    const getManagerRegist = async (targetPage = page, query = searchQuery) => {
        try {
            const getPage = (targetPage - 1) * 10;
            const params = query.trim() !== '' ? { query } : {};
            const reserve_result = await axios.get(`/ManagerRequest/${getPage}`, { params });
            setReserveList(reserve_result.data.message);
        } catch (error) {
            console.error('Error fetching reservation count:', error.message);
        }
    };
    const getReserveCount = async (query = searchQuery) => {
        try {
            const params = query.trim() !== '' ? { query } : {};
            const reserve_result = await axios.get('/ManagerRequestCount', { params });
            setReserveCount(reserve_result.data.message);
        } catch (error) {
            console.error('Error fetching reservation count:', error.message);
        }
    }
    useEffect(() => {
        getManagerRegist();
    }, [page])

    useEffect(() => {
        setIsValidAccess(true);
        getManagerRegist();
        getReserveCount();
        // 제품 리스트 가져오기
        const getProductList = async () => {
            try {
                const res = await axios.get('/PriceInfo');
                if (res.data.success) {
                    setProductList(res.data.message);
                }
            } catch (err) {
                console.error("Error fetching product list:", err);
            }
        };
        getProductList();
    }, [location.state, navigate]);

    // 주소 검색 모달 제어
    useEffect(() => {
        if (addressModalOpen) {
            addressModalRef.current?.showModal();
        } else {
            addressModalRef.current?.close();
        }
    }, [addressModalOpen]);

    // 유효한 접근이 아닌 경우 렌더링하지 않음
    if (!isValidAccess) {
        return null;
    }

    const startCorrective = () => {
        modalCorrective.current.showModal();
    }

    const getTodayDate = () => {
        const today = new Date();
        const year = today.getFullYear();
        const month = String(today.getMonth() + 1).padStart(2, '0');
        const day = String(today.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };
    // putManagerInfo 함수 수정 예시
    const putManagerInfo = async () => {
        // 백엔드에서 필수로 요구하는 필드(문서 확인): 
        // name, email, phone_num, emer_phone, address, area1, area2, area3, 
        // regist_date, rank, career, car, imposible, affili, as_count, approve_state
        const requestData = {
            name: managerInfo.name || "",
            email: managerInfo.email || "",
            phone_num: managerInfo.phone_num || "",
            emer_phone: managerInfo.emer_phone || "",
            address: managerInfo.address || "",
            area1: managerInfo.area1 || "",
            area2: managerInfo.area2 || "",
            area3: managerInfo.area3 || "",
            regist_date: managerInfo.regist_date || getTodayDate(),
            rank: managerInfo.rank || "A",
            career: managerInfo.career || "1",
            car: managerInfo.car || "무",
            imposible: managerInfo.imposible || "없음",
            affili: managerInfo.affili || "에어컨알지",
            as_count: managerInfo.as_count || "0",
            bank: managerInfo.bank || "",         // [추가] 은행
            bank_num: managerInfo.bank_num || "", // [추가] 계좌번호
            approve_state: "1", // 승인 상태
        };

        try {
            // 백엔드 라우팅: PUT /ManagerRegist/:idx
            const put_result = await axios.put(`/ManagerRegist/${managerInfo.idx}`, requestData);

            if (put_result.data.success === true) {
                alert('등록(수정)이 완료되었습니다');
                modalCorrective.current.close();
            } else {
                alert('등록(수정)에 실패하였습니다');
            }
            getManagerRegist(); // 수정 후 리스트 갱신
        } catch (error) {
            console.error('Error :', error.message);
        }
    };



    const formatPhoneNumber = (value) => {
        // 숫자만 추출
        const onlyNums = value.replace(/[^0-9]/g, '');

        // 최대 11자리로 제한
        const maxLength = 11;
        const truncatedNums = onlyNums.slice(0, maxLength);

        // 형식 적용: 010-XXXX-XXXX
        if (truncatedNums.length < 4) {
            return truncatedNums;
        } else if (truncatedNums.length < 7) {
            return `${truncatedNums.slice(0, 3)}-${truncatedNums.slice(3)}`;
        } else {
            return `${truncatedNums.slice(0, 3)}-${truncatedNums.slice(3, 7)}-${truncatedNums.slice(7)}`;
        }
    };

    const ChangeId = (e) => {
        setManagerInfo({ ...managerInfo, id: e.target.value });
    }
    const ChangePhone = (e) => {
        const formattedValue = formatPhoneNumber(e.target.value);
        setManagerInfo({ ...managerInfo, phone_num: formattedValue });
    }

    const ChangeEmerPhone = (e) => {
        const formattedValue = formatPhoneNumber(e.target.value);
        setManagerInfo({ ...managerInfo, emer_phone: formattedValue });
    }
    const ChangeAddress = (e) => {
        setManagerInfo({ ...managerInfo, address: e.target.value });
    }
    const ChangeArea1 = (e) => {
        setManagerInfo({ ...managerInfo, area1: e.target.value });
    }
    const ChangeArea2 = (e) => {
        setManagerInfo({ ...managerInfo, area2: e.target.value });
    }
    const ChangeArea3 = (e) => {
        setManagerInfo({ ...managerInfo, area3: e.target.value });
    }
    const ChangeRegistDate = (e) => {
        setManagerInfo({ ...managerInfo, regist_date: e.target.value });
    }
    const ChangeRank = (e) => {
        setManagerInfo({ ...managerInfo, rank: e.target.value });
    }
    const ChangeCareer = (e) => {
        setManagerInfo({ ...managerInfo, career: e.target.value });
    }
    const ChangeCar = (e) => {
        setManagerInfo({ ...managerInfo, car: e.target.value });
    }
    const ChangeImposible = (e) => {
        setManagerInfo({ ...managerInfo, imposible: e.target.value });
    }
    const ChangeAffili = (e) => {
        setManagerInfo({ ...managerInfo, affili: e.target.value });
    }
    const ChangeAsCount = (e) => {
        setManagerInfo({ ...managerInfo, as_count: e.target.value });
    }
    const ChangeBank = (e) => {
        setManagerInfo({ ...managerInfo, bank: e.target.value });
    }
    const ChangeBankNum = (e) => {
        setManagerInfo({ ...managerInfo, bank_num: e.target.value });
    }
    const ChangeName = (e) => {
        setManagerInfo({ ...managerInfo, name: e.target.value });
    }

    // 주소 검색 완료 핸들러
    const handleAddressComplete = (data) => {
        let fullAddress = data.address;
        let extraAddress = '';
        if (data.addressType === 'R') {
            if (data.bname !== '') extraAddress += data.bname;
            if (data.buildingName !== '') extraAddress += (extraAddress !== '' ? `, ${data.buildingName}` : data.buildingName);
            fullAddress += (extraAddress !== '' ? ` (${extraAddress})` : '');
        }
        setManagerInfo({ ...managerInfo, address: fullAddress });
        setAddressModalOpen(false);
    };

    // 세척불가품목 추가 핸들러
    const handleAddImposible = (e) => {
        const selectedItem = e.target.value;
        if (!selectedItem) return;
        let currentItems = managerInfo.imposible ? managerInfo.imposible.split(',').map(item => item.trim()).filter(item => item && item !== '없음') : [];
        if (!currentItems.includes(selectedItem)) {
            currentItems.push(selectedItem);
            setManagerInfo({ ...managerInfo, imposible: currentItems.join(', ') });
        }
    };

    // 세척불가품목 삭제 핸들러
    const handleRemoveImposible = (itemToRemove) => {
        let currentItems = managerInfo.imposible ? managerInfo.imposible.split(',').map(item => item.trim()).filter(item => item && item !== '없음') : [];
        const newItems = currentItems.filter(item => item !== itemToRemove);
        setManagerInfo({ ...managerInfo, imposible: newItems.join(', ') });
    };

    // 파일 업로드 핸들러
    const handleFileChange = async (e, uploadType) => {
        const selectedFile = e.target.files[0];
        if (!selectedFile) return;
        const renamedFile = new File([selectedFile], "image.jpg", { type: selectedFile.type });
        const formData = new FormData();
        formData.append('image', renamedFile);
        formData.append('user_id', managerInfo.email);
        try {
            const response = await axios.post(`/image/manager/${uploadType}`, formData, {
                headers: { 'Content-Type': 'multipart/form-data' },
            });
            if (response.data.success) {
                alert('이미지 업로드가 완료되었습니다.');
            } else {
                alert('이미지 업로드에 실패했습니다.');
            }
        } catch (error) {
            console.error('Error uploading image:', error.message);
        } finally {
            e.target.value = null;
        }
    };

    const triggerFileSelect = (uploadType) => {
        fileInputRef.current.setAttribute("data-upload-type", uploadType);
        fileInputRef.current.click();
    };

    const handleSearch = () => {
        if (page === 1) {
            getManagerRegist(1, searchQuery);
        } else {
            setPage(1);
        }
        getReserveCount(searchQuery);
    };

    const handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            handleSearch();
        }
    };

    return (
        <div className="dashboard-container">
            <div className="content-container">
                <SearchContainer>
                    <SearchInput
                        type="text"
                        placeholder="아이디, 이름, 연락처, 로그인방식으로 검색..."
                        value={searchQuery}
                        onChange={(e) => setSearchQuery(e.target.value)}
                        onKeyPress={handleKeyPress}
                    />
                    <SearchButton onClick={handleSearch}>검색</SearchButton>
                </SearchContainer>
                <div style={{ marginTop: '20px' }}>
                    <CommonTable headerTitle={['No', '아이디', '이름', '연락처', '로그인방식', '신청날짜', '승인']}>
                        {
                            //reserveList.slice(items * (page - 1), items * (page - 1) + items).map((reserve, index) => {
                            reserveList.map((reserve, index) => {
                                return (
                                    <CommonTableRow key={index} idx={reserve.idx} beforePage={'/manager'} kind={'notDetail'}>
                                        <CommonTableColumn>{reserveCount - ((page - 1) * 10) - index}</CommonTableColumn>
                                        <CommonTableColumn>{reserve.email}</CommonTableColumn>
                                        <CommonTableColumn>{reserve.name}</CommonTableColumn>
                                        <CommonTableColumn>{reserve.phone_num}</CommonTableColumn>
                                        <CommonTableColumn>{reserve.login_kind}</CommonTableColumn>
                                        <CommonTableColumn>{reserve.requested_at ? formatDate(reserve.requested_at) : '기록 없음'}</CommonTableColumn>
                                        <CommonTableColumn>
                                            <ApproveButton
                                                onClick={(event) => {
                                                    event.stopPropagation();
                                                    setManagerInfo({...reserve, regist_date: getTodayDate()}); // reserve 객체의 정보 세팅 (가입일자는 오늘 날짜 고정)
                                                    modalCorrective.current.showModal(); // 승인 다이얼로그 오픈
                                                }}
                                            >
                                                승인
                                            </ApproveButton>
                                        </CommonTableColumn>
                                    </CommonTableRow>
                                )
                            })
                        }
                    </CommonTable>
                </div>
                <PaginationBox>
                    <Pagination
                        activePage={page}
                        itemsCountPerPage={items}
                        totalItemsCount={reserveCount}
                        pageRangeDisplayed={10}
                        onChange={hadlePageChange}>
                    </Pagination>
                </PaginationBox>
            </div>

            <StyledDialog ref={modalCorrective}>
                <DialogHeader>
                    <h3>매니저 승인/수정</h3>
                    <CloseButton onClick={() => modalCorrective.current.close()}>&times;</CloseButton>
                </DialogHeader>
                <DialogContent>
                    <SectionTitle>인적 사항</SectionTitle>
                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '15px', marginBottom: '20px' }}>
                        <InputGroup>
                            <Label>이름</Label>
                            <StyledInput value={managerInfo.name || ''} onChange={ChangeName} />
                        </InputGroup>
                        <InputGroup>
                            <Label>E-mail</Label>
                            <StyledInput value={managerInfo.email || ''} onChange={ChangeId} />
                        </InputGroup>
                        <InputGroup>
                            <Label>연락처</Label>
                            <StyledInput value={managerInfo.phone_num || ''} onChange={ChangePhone} />
                        </InputGroup>
                        <InputGroup>
                            <Label>비상연락망</Label>
                            <StyledInput value={managerInfo.emer_phone || ''} onChange={ChangeEmerPhone} />
                        </InputGroup>
                        <InputGroup>
                            <Label>은행이름</Label>
                            <StyledInput value={managerInfo.bank || ''} onChange={ChangeBank} />
                        </InputGroup>
                        <InputGroup>
                            <Label>계좌번호</Label>
                            <StyledInput value={managerInfo.bank_num || ''} onChange={ChangeBankNum} />
                        </InputGroup>
                    </div>

                    <div style={{ marginBottom: '15px' }}>
                        <Label>주소</Label>
                        <div style={{ display: 'flex', gap: '10px' }}>
                            <StyledInput value={managerInfo.address || ''} onChange={ChangeAddress} style={{ flex: 1 }} />
                            <OutlineButton onClick={() => setAddressModalOpen(true)} style={{ whiteSpace: 'nowrap' }}>주소 검색</OutlineButton>
                        </div>
                    </div>

                    <SectionTitle style={{ marginTop: '20px' }}>근무 조건</SectionTitle>
                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '15px', marginBottom: '20px' }}>
                        <InputGroup>
                            <Label>가입일자</Label>
                            <StyledInput type="date" value={managerInfo.regist_date || ''} readOnly style={{ backgroundColor: '#f0f0f0', cursor: 'not-allowed' }} />
                        </InputGroup>
                        <InputGroup>
                            <Label>기사등급</Label>
                            <StyledSelect
                                value={managerInfo.rank || '사파이어'}
                                onChange={ChangeRank}
                                style={{ borderColor: RANK_STYLES[managerInfo.rank]?.bg || '#ddd', borderWidth: '2px' }}
                            >
                                <option value="레전드">● 레전드 (수수료 26%)</option>
                                <option value="라이트닝">● 라이트닝 (수수료 28%)</option>
                                <option value="코스믹">● 코스믹 (수수료 30%)</option>
                                <option value="토파즈">● 토파즈 (수수료 32%)</option>
                                <option value="아메시스트">● 아메시스트 (수수료 34%)</option>
                                <option value="에메랄드">● 에메랄드 (수수료 36%)</option>
                                <option value="사파이어">● 사파이어 (수수료 38%)</option>
                                <option value="루비">● 루비 (수수료 40%)</option>
                                <option value="플래티넘">● 플래티넘 (수수료 42%)</option>
                                <option value="골드">● 골드 (수수료 44%)</option>
                                <option value="실버">● 실버 (수수료 46%)</option>
                                <option value="브론즈">● 브론즈 (수수료 48%)</option>
                                <option value="아이언">● 아이언 (수수료 50%)</option>
                            </StyledSelect>
                        </InputGroup>
                        <InputGroup>
                            <Label>기사경력</Label>
                            <StyledSelect value={managerInfo.career || '1'} onChange={ChangeCareer}>
                                {careerOptions.map(year => (
                                    <option key={year} value={year}>{year}년</option>
                                ))}
                            </StyledSelect>
                        </InputGroup>
                        <InputGroup>
                            <Label>차량유무</Label>
                            <StyledSelect value={managerInfo.car || '무'} onChange={ChangeCar}>
                                <option value="유">있음</option>
                                <option value="무">없음</option>
                            </StyledSelect>
                        </InputGroup>
                        <InputGroup>
                            <Label>소속</Label>
                            <StyledInput value={managerInfo.affili || ''} onChange={ChangeAffili} />
                        </InputGroup>
                        <InputGroup>
                            <Label>AS횟수</Label>
                            <StyledInput value={managerInfo.as_count || ''} onChange={ChangeAsCount} />
                        </InputGroup>
                    </div>

                    <Label>선호지역</Label>
                    <div style={{ display: 'flex', gap: '10px', marginBottom: '15px', flexDirection: 'column' }}>
                        <RegionSelect
                            value={managerInfo.area1 || ''}
                            onChange={(val) => setManagerInfo({ ...managerInfo, area1: val })}
                            excludeRegions={[managerInfo.area2, managerInfo.area3].filter(Boolean)}
                        />
                        <RegionSelect
                            value={managerInfo.area2 || ''}
                            onChange={(val) => setManagerInfo({ ...managerInfo, area2: val })}
                            excludeRegions={[managerInfo.area1, managerInfo.area3].filter(Boolean)}
                        />
                        <RegionSelect
                            value={managerInfo.area3 || ''}
                            onChange={(val) => setManagerInfo({ ...managerInfo, area3: val })}
                            excludeRegions={[managerInfo.area1, managerInfo.area2].filter(Boolean)}
                        />
                    </div>

                    <div style={{ marginBottom: '20px' }}>
                        <Label>세척불가품목</Label>
                        <StyledSelect onChange={handleAddImposible} value="">
                            <option value="">품목 선택</option>
                            {productList
                                .filter(product => {
                                    const currentItems = managerInfo.imposible ? managerInfo.imposible.split(',').map(item => item.trim()) : [];
                                    return !currentItems.includes(product.kind);
                                })
                                .map((product, idx) => (
                                    <option key={idx} value={product.kind}>{product.kind}</option>
                                ))
                            }
                        </StyledSelect>
                        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px', marginTop: '8px' }}>
                            {managerInfo.imposible && managerInfo.imposible.split(',').map(item => item.trim()).filter(item => item && item !== '없음').map((item, idx) => (
                                <Badge key={idx} style={{ display: 'flex', alignItems: 'center', gap: '5px', paddingRight: '6px' }}>
                                    {item}
                                    <span
                                        onClick={() => handleRemoveImposible(item)}
                                        style={{ cursor: 'pointer', fontWeight: 'bold', fontSize: '1.1em', lineHeight: 0.8 }}
                                    >
                                        &times;
                                    </span>
                                </Badge>
                            ))}
                        </div>
                    </div>

                    <SectionTitle style={{ marginTop: '20px' }}>증빙 서류</SectionTitle>
                    <div style={{ display: 'flex', gap: '15px', flexWrap: 'wrap' }}>
                        <SmallOutlineButton onClick={() => triggerFileSelect('certification')}>사업자등록증 업로드</SmallOutlineButton>
                        <SmallOutlineButton onClick={() => triggerFileSelect('bank')}>통장사본 업로드</SmallOutlineButton>
                        <SmallOutlineButton onClick={() => triggerFileSelect('call')}>통신가입증명 업로드</SmallOutlineButton>
                        <SmallOutlineButton onClick={() => triggerFileSelect('pl_insurance')}>PL보험 가입증서 업로드</SmallOutlineButton>
                    </div>
                    <input
                        type="file"
                        ref={fileInputRef}
                        style={{ display: 'none' }}
                        onChange={(e) => handleFileChange(e, fileInputRef.current.getAttribute("data-upload-type"))}
                    />
                </DialogContent>
                <DialogActions>
                    <OutlineButton onClick={() => modalCorrective.current.close()}>취소</OutlineButton>
                    <ApproveButton onClick={putManagerInfo}>승인</ApproveButton>
                </DialogActions>
            </StyledDialog>

            {/* 주소 검색 모달 */}
            <StyledDialog ref={addressModalRef} onClose={() => setAddressModalOpen(false)}>
                <DialogHeader>
                    <h3>주소 검색</h3>
                    <CloseButton onClick={() => setAddressModalOpen(false)}>&times;</CloseButton>
                </DialogHeader>
                <DialogContent>
                    {addressModalOpen && <DaumPostcode onComplete={handleAddressComplete} />}
                </DialogContent>
            </StyledDialog>
        </div >
    );
}

// 1. 기본 버튼 스타일
const BaseButton = styled.button`
    padding: 8px 18px; 
    border-radius: 8px; 
    font-weight: 600;
    cursor: pointer; 
    transition: all 0.2s; 
    border: none; 
    font-size: 0.9rem;
`;

// 2. 버튼 종류별 스타일
const ApproveButton = styled(BaseButton)`
    background-color: #007bff;
    color: white;
    &:hover { background-color: #0056b3; }
`;

const OutlineButton = styled(BaseButton)`
    background-color: white; 
    border: 1px solid #ccc; 
    color: #555;
    &:hover { background-color: #f9f9f9; border-color: #bbb; }
`;

// 3. 모달(Dialog) 스타일
const StyledDialog = styled.dialog`
    border: none;
    border-radius: 16px;
    padding: 0;
    width: 90%;
    max-width: 900px;
    box-shadow: 0 10px 40px rgba(0,0,0,0.25);
    &::backdrop { background: rgba(0, 0, 0, 0.6); }
`;

const DialogHeader = styled.div`
    padding: 16px 20px; 
    border-bottom: 1px solid #eee;
    display: flex; 
    justify-content: space-between; 
    align-items: center;
    h3 { margin: 0; font-size: 1.2rem; font-weight: 700; }
`;

const DialogContent = styled.div`
    padding: 24px; 
    background: #fff; 
    max-height: 80vh; 
    overflow-y: auto;
    display: flex; 
    flex-direction: column;
`;

const DialogActions = styled.div`
    padding: 16px 20px; 
    border-top: 1px solid #eee;
    display: flex; 
    justify-content: flex-end; 
    gap: 10px;
`;

const CloseButton = styled.button`
    background: none; 
    border: none; 
    font-size: 1.8rem; 
    cursor: pointer; 
    color: #999; 
    line-height: 1;
    &:hover { color: #333; }
`;

const InputGroup = styled.div`
    margin-bottom: 1rem;
`;

const Label = styled.label`
    display: block;
    margin-bottom: 0.5rem;
    color: #555;
    font-weight: 500;
    font-size: 0.9rem;
`;

const StyledInput = styled.input`
    width: 100%;
    padding: 0.6rem;
    border: 1px solid #ddd;
    border-radius: 6px;
    font-size: 0.95rem;
    box-sizing: border-box;

    &:focus {
        outline: none;
        border-color: #007bff;
        box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.1);
    }
`;

const StyledSelect = styled.select`
    width: 100%;
    padding: 0.6rem;
    border: 1px solid #ddd;
    border-radius: 6px;
    font-size: 0.95rem;
    box-sizing: border-box;
    background-color: white;

    &:focus {
        outline: none;
        border-color: #007bff;
        box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.1);
    }
`;

const PaginationBox = styled.div`
  .pagination { display: flex; justify-content: center; margin-top: 15px;}
  ul { list-style: none; padding: 0; }
  ul.pagination li {
    display: inline-block;
    width: 30px;
    height: 30px;
    border: 1px solid #e2e2e2;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 1rem; 
  }
  ul.pagination li:first-child{ border-radius: 5px 0 0 5px; }
  ul.pagination li:last-child{ border-radius: 0 5px 5px 0; }
  ul.pagination li a { text-decoration: none; color: #337ab7; font-size: 1rem; }
  ul.pagination li.active a { color: white; }
  ul.pagination li.active { background-color: #337ab7; }
  ul.pagination li a:hover,
  ul.pagination li a.active { color: blue; }
`

const SearchContainer = styled.div`
    display: flex;
    gap: 10px;
    margin-top: 40px;
    margin-bottom: 10px;
    margin-left: 5%;
    width: auto;
    max-width: 500px;
`;

const SearchInput = styled.input`
    flex: 1;
    padding: 12px 16px;
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    font-size: 15px;
    transition: border-color 0.2s;

    &:focus {
        outline: none;
        border-color: #006edc;
    }

    &::placeholder {
        color: #999;
    }
`;

const SearchButton = styled.button`
    padding: 12px 24px;
    background-color: #006edc;
    color: white;
    border: none;
    border-radius: 8px;
    font-size: 15px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s;
    box-shadow: 0 2px 5px rgba(0,0,0,0.1);

    &:hover {
        background-color: #0056b3;
        box-shadow: 0 4px 8px rgba(0,0,0,0.15);
    }
`;

const SectionTitle = styled.h3`
    font-size: 1.1rem;
    color: #333;
    margin: 0 0 10px 0;
    border-left: 4px solid #006edc;
    padding-left: 10px;
`;

const Badge = styled.span`
    padding: 4px 10px;
    border-radius: 20px;
    font-size: 0.8rem;
    font-weight: 600;
    background-color: #e3f2fd;
    color: #1976d2;
`;

const SmallOutlineButton = styled(OutlineButton)`
    padding: 6px 12px;
    font-size: 0.85rem;
`;

// RegionSelect 컴포넌트
const RegionSelect = ({ value, onChange, excludeRegions = [] }) => {
    const [province, setProvince] = useState('');
    const [district, setDistrict] = useState('');

    useEffect(() => {
        if (value) {
            const parts = value.split(' ');
            if (parts.length >= 1) setProvince(parts[0]);
            if (parts.length >= 2) setDistrict(parts[1]);
        } else {
            setProvince('');
            setDistrict('');
        }
    }, [value]);

    const handleProvinceChange = (e) => {
        const newProvince = e.target.value;
        setProvince(newProvince);
        setDistrict('');
        onChange(newProvince ? `${newProvince}` : '');
    };

    const handleDistrictChange = (e) => {
        const newDistrict = e.target.value;
        setDistrict(newDistrict);
        onChange(province ? `${province} ${newDistrict}` : newDistrict);
    };

    const isExcluded = (prov, dist) => {
        const fullRegion = `${prov} ${dist}`;
        return excludeRegions.includes(fullRegion);
    };

    return (
        <div style={{ display: 'flex', gap: '5px', flex: 1 }}>
            <StyledSelect value={province} onChange={handleProvinceChange}>
                <option value="">시/도</option>
                {Object.keys(regionData).map(prov => (
                    <option key={prov} value={prov}>{prov}</option>
                ))}
            </StyledSelect>
            <StyledSelect value={district} onChange={handleDistrictChange} disabled={!province}>
                <option value="">시/구/군</option>
                {province && regionData[province]?.map(dist => (
                    <option key={dist} value={dist} disabled={isExcluded(province, dist)}>
                        {dist} {isExcluded(province, dist) ? '(선택됨)' : ''}
                    </option>
                ))}
            </StyledSelect>
        </div>
    );
};

export default RequestManager;
